import { render, staticRenderFns } from "./Fate.vue?vue&type=template&id=2b70d4de&"
import script from "./Fate.vue?vue&type=script&lang=js&"
export * from "./Fate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports